var _circle, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserOutlineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2880_9395",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2880_9395",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJjSURBVHgB7ZpbaiJREIbreAEvIO0VwZcWXcBkJTNbmCXMSmYJs4XMDrKD5FkU8yKIoDaKKHhL/YeUhKQlka6kPaE/aDqxBevvuv02GmLW67W/2+3+HY/HH/yvR1eOMeY2k8n8yefzjwbBb7fb+1Qq5fFBLsA3mvb7fZDNZm/MYrG45cB/uhK8cDgcIOQOAo6cDnIRLvvArdv+Fs91AZQIiJtEQNwkAuLGeQHqKxgrfjqd0mq1sgfI5XJUrVbJ8/R9oqqVYFNIw+HQnsNg80XtdtueNWAroSug1+vZ4BFgq9UitrsEk8ifQePx+HSt0+lQOp2mqECAWg8EQXAKsNvtUrFYJHG4pVLJBo1reM9sNiMt1ASg7kGz2aQwa447jqwA6Q0N1ARsNht7xt0+B5oZXKUAgb8pnb2mUfevUROAmgeSiTDQzEAyoYGagEKhYM+j0Sg0C9gPmEQAO0ELNQEISqbMYDCg5XJpX0fgqPl+v3+aUpoLLVlkYWAnYKxKP6C80CO1Wo00n358moCvAgLUI0e9o/4xcaSUMHVwNBoNtfIR1DKAZp1MJqeNfA40e71eV/NCKhlA8Ghe1DxqHEGi5l/uBgiT3kCWfN9XEaGSAcx3BPbelHk5pSASvikKKm4UwUjZvDciRSDuvGQiKpEFoO4BltNHGhTvqVQq9m9ZdlGILEBm/SX2QHpDvFEU1ARcYtBEwLmNfQnOL7LkuVDcJALiJhEQN4mAuPkWAgJymJQx5gFfSFzj+acG/818PvfZnzv1Yw8Ez0fAD9BuDF6ACDZ0f1nRL7p+AlQNG7nf5XL58QlpGFv1viohkgAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutlineIcon);
export default __webpack_public_path__ + "static/media/user-outline-icon.274482fb784fa54973677166d245d104.svg";
export { ForwardRef as ReactComponent };